import { user } from '../../reducers/user';
import { launchDarkly } from './launchDarkly';
import grades from '../../reducers/grades';
import metrics from '../../reducers/metrics';
import table from '../../reducers/table';
import restaurant from '../../reducers/restaurant';
import linechart from '../../reducers/linechart';

export const models = { user, launchDarkly, grades, metrics, restaurant, table, linechart };
